// latest: wjk 2017-12-9 10:36 AM
/* global $ u ko */
import Collection from 'common/vo/collection'
import 'collection/department'
import { Post } from 'common'

let _model
function init (refer) {
  let view
  if (refer.params) {
    view = refer.params.view || false
  } else {
    view = false
  }
  // 树形控件加载有误,所以需要每次都重新加载
  let trees = Collection.create('collection.department')
  let enterpriseId = refer.options.enterpriseId || window.global.user.enterpriseId

  let vm = {
    model: _model,
    treemodel: trees.datatable,
    view: ko.observable(view),
    treeOption: {
      callback: {
        beforeClick: async function (id, obj) {
          if (!obj.flag) {
            let { result } = await Post('/cpu-basedocrefer/basedocrefer/orgdept/getorgbyparentid', {
              enterpriseId: enterpriseId,
              parentId: obj.id
            })

            let newdata = []
            result.forEach(function (orginfo) {
              if (parseInt(orginfo.orgType) >= 2) {
                newdata.push(orginfo)
              }
            })
            trees.datatable.addSimpleData(newdata)

            obj.flag = true
          }
          vm.model.setValue('orgName', obj.name)
          vm.model.setValue('orgId', obj.id)
        }
      }
    }
  }

  trees.load({ enterpriseId: enterpriseId, parentId: 0 })
  let app = u.createApp()
  app.init(vm, $('#new_qualify_refer')[0])
}

let template = require('./index.html')
export default function (model) {
  _model = model
  return {
    init,
    template
  }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/processDefinitRefer/index.js